export default "__VITE_ASSET__baa9ce46__"